export default {
    name: "hotspot",
    hotspot: null,
    init() {
        const hotspots = document.querySelectorAll(".js-hotspot-trigger");
        const imageContainer = document.querySelector('.swiper-slide');
        if (!hotspots.length) {
            return;
        }

        hotspots.forEach((hp) => {
            this.setTolltipPosition(hp.parentElement, imageContainer);
            hp.parentElement.addEventListener("mouseout", () => {
                this.onMouseOut(hp);
            });

            hp.parentElement.addEventListener("mouseover", () => {
                this.onMouseOver(hp);
            });

            hp.addEventListener("click", () => {
                this.onMouseOver(hp);
            });

            hp.addEventListener("keydown", (e) => {
                if (e.key === "Enter") {
                    this.onMouseOver(hp);
                }
                if (e.key === "Escape") {
                    this.onMouseOut(hp);
                }
            });
        });
    },

    onMouseOver(el) {
        let { hotspot, tooltip } = this.getElements(el);
        hotspot.classList.add("active");
        tooltip.ariaHidden = false;
    },

    onMouseOut(el) {
        let { hotspot, tooltip } = this.getElements(el);
        hotspot.classList.remove("active");
        tooltip.ariaHidden = true;
    },

    getElements(el) {
        return {
            hotspot: el.parentElement,
            tooltip: el.nextElementSibling,
        };
    },
    setTolltipPosition(el, container){
        let position = '';


        if (el.offsetTop > (container.offsetHeight / 2)) {
            position = 'top';
        } else {
            position = 'bottom';
        }

        if (el.offsetLeft > container.offsetWidth / 2) {
            position += '-left';
        } else {
            position += '-right';
        }

        el.classList.add(position);

       
    },
};
